import React, { useState } from "react";
import PropTypes from "prop-types";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FaRegCalendarAlt } from "react-icons/fa";
import { IoClose } from "react-icons/io5"; // Close icon
import moment from "moment-timezone";

function DatePickerRange({
  startDate,
  endDate,
  setDateRange,
  direction = "bottom-start",
  ...props
}) {
  const [isMobileOpen, setIsMobileOpen] = useState(false);

  const handleDateChange = (dates) => {
    const [start, end] = dates;
    setDateRange({ startDate: start, endDate: end });
  };

  return (
    <div className="relative w-full max-w-[280px] flex justify-center items-center">
      {/* Date Picker Input */}
      <button
        onClick={() => setIsMobileOpen(true)}
        className="flex items-center gap-2 py-2 border rounded-lg border-gray-400 text-gray-400 text-sm bg-white w-full justify-between px-3"
      >
        <div className="flex items-center justify-center gap-1 w-full flex-1">
          {startDate && endDate ? (
            <span>
              {`${moment(startDate).format("MM-DD")} ← ${moment(endDate).format("MM-DD")}`}
            </span>
          ) : (
            <span>تصفية بالتاريخ</span>
          )}
          <FaRegCalendarAlt className="text-gray-500 text-base" />
        </div>
        {startDate && (
          <button
            type="button"
            className="text-gray-400 hover:text-red-500 transition"
            onClick={(e) => {
              e.stopPropagation();
              setDateRange({ startDate: null, endDate: null });
            }}
          >
            <IoClose className="text-lg" />
          </button>
        )}
      </button>

      {/* Desktop Date Picker */}
      <div className="hidden">
        <DatePicker
          selected={startDate}
          onChange={handleDateChange}
          startDate={startDate}
          endDate={endDate}
          selectsRange
          dateFormat="YYYY-MM-DD"
          popperPlacement={direction}
          {...props}
        />
      </div>

      {/* Mobile Fullscreen Picker */}
      {isMobileOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-4 rounded-lg shadow-lg w-11/12 max-w-lg">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-lg font-semibold">اختر نطاق التاريخ</h3>
              <button
                onClick={() => setIsMobileOpen(false)}
                className="text-gray-500 hover:text-red-500"
              >
                <IoClose size={24} />
              </button>
            </div>

            <div className="flex justify-center items-center">
              <DatePicker
                selected={startDate}
                onChange={handleDateChange}
                startDate={startDate}
                endDate={endDate}
                selectsRange
                inline
                {...props}
              />
            </div>

            <button
              onClick={() => setIsMobileOpen(false)}
              className="w-full bg-blue-500 hover:bg-blue-600 text-white py-2 rounded-lg mt-4"
            >
              تأكيد
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

DatePickerRange.propTypes = {
  startDate: PropTypes.instanceOf(Date),
  endDate: PropTypes.instanceOf(Date),
  setDateRange: PropTypes.func.isRequired,
  direction: PropTypes.string,
};

export default DatePickerRange;
